import { css } from 'lit';

export const styles = css`
  .hive-attachment-card {
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    gap: 12px;

    width: 100%;
    height: 100%;

    padding: 12px;
    border-radius: 8px;
    border: 1px solid var(--hive-background-tertiary-color);

    opacity: var(--add, 1);
    background: var(--hive-background-primary-color);
    user-select: none;
  }

  .hive-attachment-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex: 1 0 0;

    border-radius: var(--1, 0px);
    opacity: var(--add, 1);
  }

  .hive-attachment-content-title {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;

    align-self: stretch;
    padding: var(--1, 0px);
    border-radius: var(--1, 0px);
    opacity: var(--add, 1);
  }

  .hive-attachment-content-title-icon {
    display: flex;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;
  }

  .hive-attachment-content-title-icon svg {
    width: 16px;
    height: 16px;
    fill: var(--hive-background-primary-color);
  }

  .hive-attachment-content-title-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--hive-text-primary-color);

    font-family: var(--hive-font-family);
    font-size: var(--hive-font-sm);
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }

  .hive-attachment-content-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;

    word-break: break-all;
    overflow: hidden;
    color: var(--hive-text-secondary-color);
    text-overflow: ellipsis;

    font-family: var(--hive-font-family);
    font-size: var(--hive-font-xs);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .hive-attachment-banner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hive-attachment-banner svg {
    width: 40px;
    height: 40px;
  }

  .hive-attachment-card.loading {
    background: var(--hive-background-secondary-color);

    .hive-attachment-content-title-text {
      color: var(--hive-placeholder-color);
    }
  }

  .hive-attachment-card.error,
  .hive-attachment-card.unsynced {
    background: var(--hive-background-secondary-color);
  }

  .hive-attachment-card.cubeThick {
    flex-direction: column-reverse;

    .hive-attachment-content {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }

    .hive-attachment-banner {
      justify-content: flex-start;
    }
  }

  .hive-attachment-embed-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .hive-attachment-embed-event-mask {
    position: absolute;
    inset: 0;
  }
`;
